/**
 * @desc 批量完成任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  body: Array<defs.activiti.ActivitiCompleteBusinessDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/batchCompleteTask`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
